import React from 'react';

import CLocalizedTextStringStatic from '../../../components/CLocalizedTextStringStatic';
import CSortDropdown from '../../../components/CSortDropdown';
import { coMultifundFactsheetTabs } from '../../../constants/coMultifundFactsheetTabs';
import { type EFactsheetTabs } from '../../../enums/EFactsheetTabs';

interface Props {
  tabs: EFactsheetTabs[];
  currentTab: string;
  onRequestTabChange: (tab: EFactsheetTabs) => void;
}

export default function CFactsheetOutletStickyHeader(props: Props) {
  const label = CLocalizedTextStringStatic('fsNavigation');
  const options = props.tabs.reduce((previousValue: Record<string, string>, currentValue: EFactsheetTabs) => {
    previousValue[currentValue] = CLocalizedTextStringStatic(coMultifundFactsheetTabs[currentValue].dictKey);
    return previousValue;
  }, {});

  return (
    <div className={'flex justify-end'}>
      <CSortDropdown
        labelDesc={label}
        onChange={(v) => {
          props.onRequestTabChange(v as EFactsheetTabs);
        }}
        options={options}
        defaultKey={props.currentTab}
      />
    </div>
  );
}
